var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9463 17.627H22.9463V19.627H2.94629V17.627H4.94629V10.627C4.94629 6.20867 8.52801 2.62695 12.9463 2.62695C17.3646 2.62695 20.9463 6.20867 20.9463 10.627V17.627ZM18.9463 17.627V10.627C18.9463 7.31324 16.26 4.62695 12.9463 4.62695C9.63258 4.62695 6.94629 7.31324 6.94629 10.627V17.627H18.9463ZM9.94629 21.627H15.9463V23.627H9.94629V21.627Z",
    fill: "#193975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm);
export default __webpack_public_path__ + "static/media/icon_alarm.777a00674b95087e2fbb6b2e04efb33d.svg";
export { ForwardRef as ReactComponent };